// Custom fetch using XMLHttpRequest to bypass monitoring script issues
export const safeFetch = async (url, options = {}) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(options.method || 'GET', url);
    
    // Set headers
    if (options.headers) {
      Object.keys(options.headers).forEach(key => {
        xhr.setRequestHeader(key, options.headers[key]);
      });
    }
    
    // Handle credentials
    if (options.credentials === 'include') {
      xhr.withCredentials = true;
    }
    
    xhr.onload = () => {
      const response = {
        ok: xhr.status >= 200 && xhr.status < 300,
        status: xhr.status,
        statusText: xhr.statusText,
        json: async () => {
          try {
            return JSON.parse(xhr.responseText);
          } catch (e) {
            return {};
          }
        },
        text: async () => xhr.responseText,
      };
      resolve(response);
    };
    
    xhr.onerror = () => reject(new Error('Network request failed'));
    xhr.ontimeout = () => reject(new Error('Network request timeout'));
    
    // Send request
    if (options.body) {
      xhr.send(options.body);
    } else {
      xhr.send();
    }
  });
};
